import { getNumbersFromStr } from '../text/get-numbers-from-str';

import type { TValidatorValue } from './models';
import { validateNotEmpty } from './not-empty';
import { composeValidators, validate } from './utils';

export const DEFAULT_PHONE_MESSAGE = 'Введен некорректный номер телефона';

/**
 * Валидирует строку с телефоном
 */
export const isValidPhone = (value?: string, blockedPhones: string[] = []): boolean => {
    const clearValue = getNumbersFromStr(value);

    // Проверяем, что телефон полного формата 79991112233
    if (clearValue.length !== 11) {
        return false;
    }

    // Проверяем, что первые цифры (после кода страны) не 1, 2, 7
    if (['0', '1', '2', '5'].includes(clearValue[1])) {
        return false;
    }

    // Проверяем, что телефон не из чёрного списка
    return !blockedPhones.some(phone => phone === clearValue);
};

export const validatePhoneValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidPhone(value), DEFAULT_PHONE_MESSAGE, customMessage);

export const validatePhone = (message?: string) =>
    composeValidators(validateNotEmpty(), validatePhoneValue(message));
